// roles: ['admin', 'editor'/* 내부교역자 */ , 'user' /* 그외 */]
// roles 속성이 없으면 모든 사용자가 볼 수 있습니다.

export const menuConfig = [
  {
    title: "관리자",
    id: "nav-admin",
    roles: ["admin", "editor"],
    items: [
      { eventKey: "2.1", href: "/MainSwiperList", text: "배너관리" },
      { eventKey: "2.2", href: "/MainPopupList", text: "팝업관리" },
      { eventKey: "2.3", href: "/MainToastList", text: "TOAST관리" },
      { eventKey: "2.4", href: "/ReadingBible", text: "성경읽기관리" },
      { eventKey: "2.5", href: "/Semp", text: "특새관리" },
      { eventKey: "2.6", href: "/MybbsMaster", text: "게시물관리" },
      { eventKey: "2.7", href: "/TitleImageList", text: "타이틀 이미지 관리" },
    ],
  },
  {
    title: "예배",
    id: "nav-worship",
    roles: ["admin", "editor"],
    items: [{ eventKey: "3.1", href: "/Video", text: "예배영상" }],
  },
  {
    title: "소식",
    id: "nav-news",
    roles: ["admin", "editor"], // 관리자와 에디터만 접근 가능
    items: [
      { eventKey: "4.1", href: "/Weekly", text: "주보" },
      { eventKey: "4.1.1", href: "/WeeklyList", text: "주보목록" },
      { eventKey: "4.2", href: "/News", text: "교회소식" },
      { eventKey: "4.3", href: "/Board/archive", text: "자료실" },
    ],
  },
  {
    title: "사진",
    id: "photo-board",
    items: [
      { eventKey: "5.4", href: "/PhotoList", text: "사진게시판" },
      { eventKey: "1.2", href: "/adminboard", text: "운영자 게시판" },
    ],
  },
  {
    title: "다음세대",
    id: "nextgen-photo-board",
    roles: ["admin", "editor"],
    items: [
      { eventKey: "6.1", href: "/nextgen/kobi", text: "코비 사진" },
      { eventKey: "6.2", href: "/nextgen/koch", text: "코치 사진" },
      { eventKey: "6.3", href: "/nextgen/koki", text: "코키 사진" },
      { eventKey: "6.4", href: "/nextgen/koding", text: "코딩 사진" },
    ],
  },
  {
    title: "회원관리",
    id: "nav-members",
    roles: ["admin", "editor"], // 관리자와 에디터만 접근 가능
    items: [
      { eventKey: "4.1", href: "/Joinlist", text: "가입신청" },
      { eventKey: "4.2", href: "/Members", text: "회원관리" },
    ],
  },
  {
    title: "어드민",
    id: "nav-adminuser",
    roles: ["admin"],
    items: [{ eventKey: "1.1", href: "/UserList", text: "관리자계정" }],
  },
];
